import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Loader2, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem('admin_token', res.data.token);
      navigate('/admin');
    } catch (e) {
      setError(e.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bone flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <button data-testid="admin-back-btn" onClick={() => navigate('/')} className="mb-8 text-text-muted flex items-center gap-2 text-sm hover:text-espresso transition-colors">
          <ArrowLeft size={16} /> Back to Guest Portal
        </button>
        <div className="mb-8">
          <h1 data-testid="admin-login-title" className="font-heading text-3xl text-espresso mb-2">Property Manager</h1>
          <p className="text-text-muted text-sm">Sign in to manage your property</p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-text-muted font-semibold mb-2 block">Email</label>
            <Input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@hostbase.com"
              className="bg-white border border-warm-border rounded-xl"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-text-muted font-semibold mb-2 block">Password</label>
            <Input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="bg-white border border-warm-border rounded-xl"
              onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
            />
          </div>
          {error && <p data-testid="admin-login-error" className="text-warm-error text-sm">{error}</p>}
          <Button
            data-testid="admin-login-btn"
            onClick={handleLogin}
            disabled={loading}
            className="w-full bg-espresso hover:bg-espresso-light text-white rounded-full h-12 mt-2"
          >
            {loading && <Loader2 className="animate-spin mr-2" size={18} />}
            Sign In
          </Button>
        </div>
      </div>
    </div>
  );
}
